import { Box, Card, Group, Text } from '@mantine/core';
import { useState } from 'react';
import type { CSSProperties, ReactNode } from 'react';

interface EventCardProps {
  children: ReactNode;
  meta?: ReactNode;
  background?: string;
  actions?: ReactNode;
  actionsVisibility?: 'always' | 'hover';
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  radius?: string | number;
  style?: CSSProperties;
}

/**
 * EventCard — базовая карточка события с единым видом.
 */
export function EventCard({
  children,
  meta,
  background,
  actions,
  actionsVisibility = 'always',
  onClick,
  onMouseEnter,
  onMouseLeave,
  radius,
  style: styleProp,
}: EventCardProps) {
  const [hovered, setHovered] = useState(false);
  const style: CSSProperties = {
    ...(background ? { background } : null),
    ...(onClick ? { cursor: 'pointer' } : null),
    overflowWrap: 'anywhere' as const,
    wordBreak: 'break-word',
    ...(styleProp ?? null),
  };
  const showActions = actionsVisibility === 'always' || hovered;

  return (
    <Card
      padding='sm'
      shadow='xs'
      mb={4}
      style={style}
      radius={radius}
      onClick={onClick}
      onMouseEnter={() => {
        setHovered(true);
        onMouseEnter?.();
      }}
      onMouseLeave={() => {
        setHovered(false);
        onMouseLeave?.();
      }}
    >
      <Group align='flex-start' justify='space-between' wrap='nowrap' gap='xs'>
        <Box style={{ flex: 1, minWidth: 0 }}>
          {children}
          {meta && (
            <Text size='xs' c='dimmed' mt={2}>
              {meta}
            </Text>
          )}
        </Box>
        {actions && (
          <Box
            onClick={e => e.stopPropagation()}
            style={{
              opacity: showActions ? 1 : 0,
              pointerEvents: showActions ? 'auto' : 'none',
              transition: 'opacity 120ms ease',
            }}
          >
            {actions}
          </Box>
        )}
      </Group>
    </Card>
  );
}
